// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__KMLhm","errors":"Errors_errors__3G86M"};